export const DEFAULT_INITIAL_ROUTE = process.env.REACT_APP_DEFAULT_INITIAL_ROUTE;

// these needs to be in an environment variable
export const BLITZ_CI_AUTH = process.env.REACT_APP_BLITZ_CI_AUTH; // access token key 
export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const COMMISSIONS_API_BASE_URL = process.env.REACT_APP_COMMISSIONS_API_BASE_URL;
export const PRIVATE_KEY = process.env.REACT_APP_PRIVATE_KEY; // key for utils/encrypter
export const WEBSCRAPERS_API_BASE_URL = process.env.REACT_APP_WEB_SCRAPERS_API_BASE_URL; // base url for webscrapers api

export const FIREBASE_API_KEY = process.env.REACT_APP_FIREBASE_API_KEY;
export const FIREBASE_AUTH_DOMAIN = process.env.REACT_APP_FIREBASE_AUTH_DOMAIN;
export const FIREBASE_PROJECT_ID = process.env.REACT_APP_FIREBASE_PROJECT_ID;
export const FIREBASE_STORAGE_BUCKET = process.env.REACT_APP_FIREBASE_STORAGE_BUCKET;
export const FIREBASE_MESSAGING_SENDER_ID = process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID;
export const FIREBASE_APP_ID = process.env.REACT_APP_FIREBASE_APP_ID;
